export type PaywallOffer = {
  id: string;
  kind: string;
  price_kopecks: string;
  coverage_kind?: string;
  trainer_slug?: string;
  title?: string;
};

export type PaywallView = {
  mode: "child" | "parent";
  title: string;
  body: string;
  cta: string;
  offers: PaywallOffer[];
  showPrices: boolean;
};

export function paywallView(parentUnlocked: boolean, offers: PaywallOffer[]): PaywallView {
  if (!parentUnlocked) {
    return {
      mode: "child",
      title: "Пробный доступ закончился",
      body: "Позови взрослого, чтобы выбрать доступ и продолжить с места остановки.",
      cta: "Позвать взрослого",
      offers: [],
      showPrices: false,
    };
  }
  return {
    mode: "parent",
    title: "Пробный доступ закончился",
    body: "Прогресс сохранён. Выберите вариант доступа, чтобы продолжить.",
    cta: "Выбрать доступ",
    offers,
    showPrices: true,
  };
}

export function offerLabel(offer: PaywallOffer): string {
  const catalog = offer.coverage_kind === "catalog";
  if (offer.kind === "monthly") return catalog ? "Подписка на каталог" : "Подписка на тренажёр";
  return catalog ? "Разовая покупка каталога" : "Разовая покупка тренажёра";
}
